module.exports = __webpack_public_path__ + "static/media/Replay.b6148b05.svg";